import { Button, DatePicker, Modal } from 'antd';
import locale from 'antd/es/date-picker/locale/ko_KR';
import moment from 'moment';
import 'moment/locale/ko';
import React, { useEffect, useState } from 'react';
import { withAlert } from 'react-alert';
import { connect } from 'react-redux';
import * as XLSX from 'xlsx';
import { httpPost, httpUrl } from '../../api/httpClient';
import { comma } from '../../lib/util/numberUtil';
import Pagination from '../input/Pagination';
import DeliveryDetailModal from '../modal/DeliveryDetailModal';
import image from '../../res/image';

const { RangePicker } = DatePicker;
const PagedListSize = 5;
const dateFormat = 'YYYY-MM-DD';
const now = new Date();

const header = [
  {
    orderIdx: '주문번호',
    orderDate: '일시',
    destAddr: '고객주소',
    custPhone: '고객번호',
    totalPrice: '결제금액',
    riderName: '기사명',
    riderPhone: '기사번호',
  },
];

const defDateType = {
  daily: 0,
  weekly: 1,
  monthly: 2,
  range: 3,
};

const CashList = () => {
  const [detailModalOpen, setDetailModalOpen] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 8,
    startDate: now,
    endDate: now,
  });
  const [list, setList] = useState([]);
  const [total, setTotal] = useState(0);
  const [currentList, setCurrentList] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [dateType, setDateType] = useState(defDateType.daily);
  const [cashSum, setcashSum] = useState(0);
  const [isOpenRangePicker, setIsOpenRangePicker] = useState(false);

  useEffect(() => {
    getListAsync();
  }, [pagination]);

  const getListAsync = async () => {
    const pageSize = pagination.pageSize;
    const pageNum = pagination.current;
    const startDate = moment(pagination.startDate).format(dateFormat);
    const endDate = moment(pagination.endDate)
      .add(1, 'days')
      .format(dateFormat);
    try {
      const res = await httpPost(httpUrl.cashPaymentList, [], {
        endDate,
        pageNum,
        pageSize,
        startDate,
      });
      if (res.result !== 'SUCCESS') {
        // console.log(`getListAsync failed. result: ${res.result}`);
        return;
      }
      if (res.data !== null) {
        // console.log(res.data.cashPayments + '111');
        setList(res.data.cashPayments);
        setTotal(res.data.totalCount);
        setcashSum(res.data.cashSum);
      }
    } catch (e) {
      setList([]);
      setTotal(0);
      console.warn('getListAsync failed. ' + e);
    }
  };

  const onChange = (page) => {
    setPagination({
      ...pagination,
      current: page,
    });
  };

  const onChangeDatePickerStart = (_, dateString) => {
    if (dateString) {
      if (new Date(pagination.endDate) - new Date(dateString) > 0) {
        setPagination({
          ...pagination,
          current: 1,
          startDate: dateString,
        });
      } else {
        setPagination({
          ...pagination,
          current: 1,
          startDate: pagination.endDate,
          endDate: dateString,
        });
      }
      // setDateType(defDateType.range);
    } else {
      setPagination({
        ...pagination,
        current: 1,
        // startDate: now,
        startDate: moment(now).add(-3, 'M').format(dateFormat),
        endDate: now,
      });
      // setDateType(defDateType.range);
    }
  };

  const onChangeDatePickerEnd = (_, dateString) => {
    if (dateString) {
      if (new Date(pagination.startDate) - new Date(dateString) < 0) {
        setPagination({
          ...pagination,
          current: 1,
          endDate: dateString,
        });
      } else {
        setPagination({
          ...pagination,
          current: 1,
          startDate: dateString,
          endDate: pagination.startDate,
        });
      }
      // setDateType(defDateType.range);
    } else {
      setPagination({
        ...pagination,
        current: 1,
        // startDate: now,
        startDate: moment(now).add(-3, 'M').format(dateFormat),
        endDate: now,
      });
      // setDateType(defDateType.daily);
    }
  };

  const onChangeRangePicker = (dateString) => {
    const startDate = dateString[0];
    const endDate = dateString[1];

    setPagination({
      ...pagination,
      current: 1,
      startDate,
      endDate,
    });
    setDateType(defDateType.range);
    setIsOpenRangePicker(false);
  };

  const onOpenChangeRangePicker = (open) => {
    setIsOpenRangePicker(open);
  };

  const onChangeDateType = (dateType) => {
    let startDate, endDate;
    let isOpenRangePicker = false;

    switch (dateType) {
      case defDateType.daily:
        startDate = now;
        endDate = now;
        break;

      case defDateType.weekly:
        startDate = moment(now).add(-7, 'days');
        endDate = now;
        break;

      case defDateType.monthly:
        startDate = moment(now).add(-30, 'days');
        endDate = now;
        break;

      case defDateType.range:
        isOpenRangePicker = true;
        break;

      default:
        return;
    }

    setDateType(dateType);
    setIsOpenRangePicker(isOpenRangePicker);

    if (dateType !== defDateType.range) {
      setPagination({
        ...pagination,
        current: 1,
        startDate: startDate,
        endDate: endDate,
      });
    }
  };

  const onDownload = async () => {
    const startDate = moment(pagination.startDate).format(dateFormat);
    const endDate = moment(pagination.endDate)
      .add(1, 'days')
      .format(dateFormat);
    const pageNum = 1;
    const pageSize = 100000000;

    const res = await httpPost(httpUrl.cashPaymentList, [], {
      endDate,
      pageNum,
      pageSize,
      startDate,
    });
    if (res.result !== 'SUCCESS') {
      Modal.error({
        title: '엑셀 다운로드 오류',
        content: (
          <div>
            엑셀로 저장하는 동안 오류가 발생했습니다. 다시 시도해 주십시오.
          </div>
        ),
      });
      return;
    }

    // console.log(res);

    const title = '통계';
    const filename = moment().format('YYYYMMDDhhmmss') + '_' + title + '.xlsx';

    const jsonData = res.data.cashPayments.map((row) => ({
      orderIdx: row.orderIdx,
      orderDate: moment(row.orderDate).format('YYYY-MM-DD HH:mm'),
      destAddr: row.destAddr1 + ' ' + row.destAddr2,
      custPhone: row.custPhone,
      totalPrice: row.paymentAmount,
      riderName: row.riderName + ' ' + row.riderPhone,
      riderPhone: row.riderPhone,
    }));

    const array = header.concat(jsonData);

    var ws = XLSX.utils.json_to_sheet(array, { skipHeader: true });
    var wb = XLSX.utils.book_new();

    ws['!cols'] = [];
    ws['!cols'][1] = { width: 20 };
    ws['!cols'][2] = { width: 40 };
    ws['!cols'][3] = { width: 17 };
    ws['!cols'][6] = { width: 17 };
    ws['!cols'][7] = { width: 20 };
    // ws["!cols"][8] = { width: 20 };

    XLSX.utils.book_append_sheet(wb, ws, '현금결제목록');
    XLSX.writeFile(wb, filename);
  };

  const openDetailModal = (order) => {
    setSelectedRow(order);
    setDetailModalOpen(true);
  };

  const closeDetailModal = () => {
    setSelectedRow(null);
    setDetailModalOpen(false);
  };

  return (
    <React.Fragment>
      {/* 상단 */}
      <div className="delivery-element delivery-element-card">
        {/* <div className="desk" style={{ height: 70 }} />
                <div className="pos" style={{ height: 60 }} /> */}
        <DeliveryDetailModal
          data={selectedRow}
          isOpen={detailModalOpen}
          close={closeDetailModal}
        />
        <div className="card-list-menu">
          <div
            className="delivery-element-card-btn-excel mobileoff"
            onClick={() => {}}>
            <Button className="excel-card" onClick={() => onDownload()}>
              엑셀 다운로드 &nbsp;
              <img
                style={{ display: 'inline' }}
                src={image.DownloadIcon}
                className="download-img"
                alt=""
              />
            </Button>
          </div>
          <div className="card-list-menu-all">
            <div className="card-list-menu-text2">
              <div className="card-list-menu-2">
                <div className="card-statics-menu-text">기간조회</div>
                <div
                  className={
                    'card-list-menu-text2' +
                    (dateType === defDateType.daily ? ' active2' : '')
                  }
                  onClick={() => onChangeDateType(defDateType.daily)}>
                  오늘
                </div>
                {/* <div
                  className={
                    "card-list-menu-text2" +
                    (dateType === defDateType.weekly ? " active2" : "")
                  }
                  onClick={() => onChangeDateType(defDateType.weekly)}
                >
                  일주일
                </div> */}
                <div
                  className={
                    'card-list-menu-text2' +
                    (dateType === defDateType.monthly ? ' active2' : '')
                  }
                  onClick={() => onChangeDateType(defDateType.monthly)}>
                  한달
                </div>
                <div
                  className={
                    'card-list-menu-text2' +
                    (dateType === defDateType.range
                      ? ' active2'
                      : ' del-menu-text2-sub')
                  }
                  onClick={() => onChangeDateType(defDateType.range)}>
                  날짜지정
                </div>

                <div className="desk">
                  <DatePicker
                    placeholder={'시작일'}
                    locale={locale}
                    style={{
                      marginLeft: '10px',
                      height: '50px',
                      borderRadius: '10px',
                      marginTop: '-5px',
                      textAlign: 'center',
                      fontFamily: 'NotoSansMedium',
                    }}
                    size="large"
                    format={dateFormat}
                    value={moment(pagination.startDate, dateFormat)}
                    onChange={onChangeDatePickerStart}
                  />
                  <DatePicker
                    placeholder={'종료일'}
                    locale={locale}
                    style={{
                      // marginLeft: "10px",
                      height: '50px',
                      borderRadius: '10px',
                      marginTop: '-5px',
                      textAlign: 'center',
                      fontFamily: 'NotoSansMedium',
                    }}
                    size="large"
                    format={dateFormat}
                    value={moment(pagination.endDate, dateFormat)}
                    onChange={onChangeDatePickerEnd}
                  />
                </div>

                <div className="pos">
                  <DatePicker
                    placeholder={'시작일'}
                    locale={locale}
                    style={{
                      marginLeft: '10px',
                      height: '40px',
                      borderRadius: '10px',
                      marginTop: '-5px',
                      textAlign: 'center',
                    }}
                    size="middle"
                    format={dateFormat}
                    value={moment(pagination.startDate, dateFormat)}
                    onChange={onChangeDatePickerStart}
                  />
                  <DatePicker
                    placeholder={'종료일'}
                    locale={locale}
                    style={{
                      // marginLeft: "10px",
                      height: '40px',
                      borderRadius: '10px',
                      marginTop: '-5px',
                      textAlign: 'center',
                    }}
                    size="middle"
                    format={dateFormat}
                    value={moment(pagination.endDate, dateFormat)}
                    onChange={onChangeDatePickerEnd}
                  />
                </div>

                <div className="mobile">
                  <DatePicker
                    placeholder={'시작일'}
                    locale={locale}
                    style={{
                      height: '32px',
                      borderRadius: '6px',
                      marginTop: '5px',
                    }}
                    size="small"
                    format={dateFormat}
                    value={moment(pagination.startDate, dateFormat)}
                    onChange={onChangeDatePickerStart}
                  />
                  <DatePicker
                    placeholder={'종료일'}
                    locale={locale}
                    style={{
                      height: '32px',
                      borderRadius: '6px',
                      marginTop: '5px',
                    }}
                    size="small"
                    format={dateFormat}
                    value={moment(pagination.endDate, dateFormat)}
                    onChange={onChangeDatePickerEnd}
                  />
                </div>
                <div className="delivery-complete-list desk">
                  <div style={{ background: '#fff4ec' }}>
                    총 : {comma(cashSum)} 원
                  </div>
                </div>
                <div className="delivery-complete-list pos">
                  <div style={{ background: '#fff4ec' }}>
                    총 : {comma(cashSum)} 원
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="delivery-element-all-card">
          <div className="delivery-card-block">
            <div className="delivery-cash-block-menu">
              <div className="delivery-cash-block-menu-text mobileoff">
                주문번호
              </div>
              <div className="delivery-cash-block-menu-text mobileoff">
                일시
              </div>
              <div className="delivery-cash-block-menu-text del-card2">
                고객정보
              </div>
              <div className="delivery-cash-block-menu-text">결제금액</div>
              <div className="delivery-cash-block-menu-text mobileoff">
                기사정보
              </div>
              <div className="delivery-cash-block-menu-text mobile">상세</div>
            </div>
          </div>
          <div className="cardList-wrapper">
            {(!list || list.length === 0) && (
              <div style={{ textAlign: 'center', padding: '50px' }}>
                내역이 없습니다.
              </div>
            )}

            {list &&
              list.map((row, index) => (
                <div
                  key={index}
                  className={
                    'delivery-cash-block-field' +
                    (index % 2 === 0 ? '' : ' odd')
                  }
                  // onClick={() => openDetailModal(row)}
                >
                  <div className="delivery-cash-block-field-text mobileoff">
                    {row.orderIdx}
                  </div>
                  <div className="delivery-cash-block-field-text mobileoff">
                    {moment(row.createDate).format('YYYY-MM-DD HH:mm')}
                  </div>
                  <div className="delivery-cash-block-field-text del-card-sub2">
                    {row.destAddr1}
                    {row.destAddr2}{' '}
                    <span className="delivery-card-block-field-text-sub">
                      ({row.custPhone})
                    </span>
                  </div>
                  <div className="delivery-cash-block-field-text">
                    {comma(row.paymentAmount)}원
                  </div>
                  <div className="delivery-cash-block-field-text mobileoff">
                    {row.riderName} /{' '}
                    <span className="delivery-card-block-field-text-sub">
                      {row.riderPhone}
                    </span>
                  </div>
                  {/* <div className="delivery-card-block-field-text">
                    <div
                      className={`del-card-sub5${
                        row.authType == 0 ? "" : "-cancel"
                      } mobileoff`}
                    >
                      {row.authType == 0 ? "승인완료" : "승인취소"}
                    </div>
                    <div
                      className={`del-card-sub5${
                        row.authType == 0 ? "" : "-cancel"
                      } mobile`}
                    >
                      {row.authType == 0 ? "완료" : "취소"}
                    </div>
                  </div> */}
                  <div className="delivery-element-block-field-text mobile">
                    <Button className="del-btn">상세</Button>
                  </div>
                </div>
              ))}
          </div>
        </div>

        <div className="delivery-element-btn">
          <Pagination
            current={pagination.current}
            total={total}
            pageSize={pagination.pageSize}
            pagedListSize={PagedListSize}
            onChange={onChange}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

// const mapStateToProps = (state) => {
//   const { posReducer } = state;
//   return { posReducer };
// };
const mapDispatchToProps = null;

export default connect(mapDispatchToProps)(withAlert()(CashList));
